import { InjectionToken, InputSignal, Provider, Type } from '@angular/core';
import { Contract } from './contract';

export interface ContractWidget {
    contract: Contract | InputSignal<Contract>;
}

export interface ContractWidgetConfig {
    component: Type<ContractWidget>;
}

export const DEFAULT_CONTRACT_WIDGETS = new InjectionToken<ContractWidgetConfig[]>('defaultContractWidgetsToken');

export const provideDefaultWidgets = (widgets: ContractWidgetConfig[]): Provider[] =>
    widgets.map((widget) => ({ provide: DEFAULT_CONTRACT_WIDGETS, useValue: widget, multi: true }));
